import React from 'react';
import { Container } from './DashboardAdm.styles';

function DashboardAdm() {
    return <Container>Dashboard</Container>;
}

export default DashboardAdm;
